import { OnInit, Component, EventEmitter, Output, Input } from '@angular/core';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { OrganisationsService } from '../../services';
import { UserService } from '../../services';
import { flatten } from '../../utils/flatten';
import { SelectItem } from 'primeng';
import { IOrganisationFilter } from '../../interfaces/organisation-filter';

@Component({
  selector: 'organisation-select-list',
  templateUrl: './organisation-select-list.component.html',
  styleUrls: [],
})
export class OrganisationSelectListComponent implements OnInit {
  public isVmeMode: boolean;
  public currentUserOrgTypeId: number;
  public currentUserOrgId: number;
  public organisationsList: SelectItem[];
  public organisationFilterVal: IOrganisationFilter;
  public organisationFilter: Subject<IOrganisationFilter>;
  public selectedValue: number;
  public selectedOption: SelectItem;

  @Input()
  minTextLength: number = 1;

  @Input()
  selectPlaceHolderText: string = 'Type to search organisations';

  @Input()
  selectedOrganisationId: number;

  @Input()
  organisationTypeId: number;

  @Input()
  formName: string = 'organisationsList';

  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private userService: UserService,
    private organisationService: OrganisationsService,
  ) {}

  ngOnInit() {
    this.organisationFilter = new Subject<IOrganisationFilter>();
    this.organisationsList = [];
    this.userService.getCurrentUserOrg().then((res) => {
      this.currentUserOrgId = res.id;
      this.currentUserOrgTypeId = res.organisationTypeId;
      this.isVmeMode = res.organisationTypeId == 1;

      if (this.isVmeMode) {
        this.organisationFilter.pipe(debounceTime(50)).subscribe((o) => {
          this.loadOrganisations(o);
          this.organisationFilterVal = o;
        });
        //if a value was received from the input
        if (this.selectedOrganisationId) {
          this.organisationFilterVal.filters.id.value = this.selectedOrganisationId;
          this.loadOrganisations(this.organisationFilterVal);
        }
      }
    });
    this.initialiseDefaultFilters();
  }

  initialiseDefaultFilters() {
    this.organisationFilterVal = {
      first: 0,
      rows: null,
      sortField: null,
      sortOrder: 1,
      filters: {
        name: { value: null },
        id: { value: null },
        organisationTypeId: {
          value: this.organisationTypeId != null ? this.organisationTypeId : null,
        },
      },
    };
  }

  // user actually typing to change the value of the input box
  onInputTextChanged(event: any) {
    this.selectedOrganisationId = null;
    let enter_arrowCodes = [13, 37, 38, 39, 40];
    if (enter_arrowCodes.indexOf(event.keyCode) < 0) {
      this.organisationsList = [];
      this.organisationFilterVal.filters.name.value = null;
      var value = event.target.value;
      if (value.length > this.minTextLength) {
        this.organisationFilterVal.filters.name.value = value;
        this.organisationFilter.next(this.organisationFilterVal);
      } else if (value.length < 1) {
        // user has cleared the input text
        this.selectedValue = null;
        this.valueChange.emit(this.selectedValue);
      }
    }
  }

  loadOrganisations(organisationFilter: IOrganisationFilter) {
    this.organisationService.getSelectList(flatten(organisationFilter)).then((res) => {
      this.organisationsList = res;
      if (this.selectedOrganisationId)
        this.selectedOption = res.filter((t) => t.value == this.selectedOrganisationId)[0];
      this.organisationFilterVal.filters.id.value = null;
    });
  }

  onSelectChange(event: any) {
    let newValue: any = null;

    if (event.value) {
      newValue = event.value.value;
    }

    this.selectedValue = newValue;

    if (event.keyCode === 13) {
      this.selectedValue = event.value.value;
    }

    this.valueChange.emit(this.selectedValue);
  }
}
